import BaseChannelSerializer from '@square/dashboard-data/serializers/channels/base-channel-serializer';
export default class Location extends BaseChannelSerializer {
  modelNameFromPayloadKey() {
    return 'channels/location';
  }
}